enum MoveCubukPosition {
    Left = "left",
    Right = "right"
}

export default MoveCubukPosition;
